import { render } from "./sales-card.vue?vue&type=template&id=cf91f228&scoped=true"
import script from "./sales-card.vue?vue&type=script&lang=js"
export * from "./sales-card.vue?vue&type=script&lang=js"

import "./sales-card.vue?vue&type=style&index=0&id=cf91f228&scoped=true&lang=css"
import "./sales-card.vue?vue&type=style&index=1&id=cf91f228&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf91f228"]])

export default __exports__